import { IconButton, Tooltip } from '@treezor/design-system';

import { useSCAActions } from '../hooks/useSCAActions';

import { IScaWallet } from '@/store/models/sca.model';

interface ISCAActionsProps {
  scaWallet: IScaWallet;
}

export function SCAActions({ scaWallet }: ISCAActionsProps) {
  const { actionList, actions, ConfirmDelete, ConfirmResetPIN, ConfirmUnlockSCA } = useSCAActions({ scaWallet });

  return (
    <>
      {actionList?.length > 0 && (
        <div className="flex items-center justify-end">
          {actionList?.map((key) => {
            const { tooltip, ...iconProps } = actions[key];
            return (
              <Tooltip key={`sca-tooltip-${key}`} messageContent={tooltip} contentClassName="whitespace-nowrap">
                <IconButton {...iconProps} variant="secondary" />
              </Tooltip>
            );
          })}
        </div>
      )}
      <ConfirmDelete.ConfirmationDialog />
      <ConfirmResetPIN.ConfirmationDialog />
      <ConfirmUnlockSCA.ConfirmationDialog />
    </>
  );
}
